<template>
    <div>
        <div v-if="subscriptionSuccess">
            <div class="alert alert-success">
                Bedankt voor uw inschrijving! U ontvangt een bevestigingsmail.
            </div>

            <div class="text-center">
                <button type="button" class="btn btn-lg btn-primary" @click="subscriptionSuccess = false">
                    Nog een inschrijving
                </button>
            </div>
        </div>

        <form method="post" @submit.prevent="submit" v-else>
            <div class="form-group">
                <label for="firstname">Voornaam *</label>
                <input type="text" class="form-control" id="firstname" v-model="fields.firstname" v-bind:class="{ 'is-invalid' : errors.firstname }">
            </div>
            <div class="form-group">
                <label for="lastname">Achternaam *</label>
                <input type="text" class="form-control" id="lastname" v-model="fields.lastname" v-bind:class="{ 'is-invalid' : errors.lastname }">
            </div>
            <div class="form-group">
                <label for="postcode">Postcode *</label>
                <input type="text" class="form-control" id="address" v-model="fields.postcode" v-bind:class="{ 'is-invalid' : errors.postcode }">
            </div>
            <div class="form-group">
                <label for="address">Straat + huisnummer *</label>
                <input type="text" class="form-control" id="address" v-model="fields.address" v-bind:class="{ 'is-invalid' : errors.address }">
            </div>
            <div class="form-group">
                <label for="city">Woonplaats *</label>
                <input type="text" class="form-control" id="city" v-model="fields.city" v-bind:class="{ 'is-invalid' : errors.city }">
            </div>
            <div class="form-group">
                <label for="telephone">Telefoonnummer *</label>
                <input type="text" class="form-control" id="telephone" v-model="fields.telephone" v-bind:class="{ 'is-invalid' : errors.telephone }">
            </div>
            <div class="form-group">
                <label for="email">E-mailadres *</label>
                <input type="email" class="form-control" id="email" v-model="fields.email" v-bind:class="{ 'is-invalid' : errors.email }">
            </div>
            <div class="form-group">
                <label for="comes_on">Ik kom op *</label>
                <select class="form-control" id="comes_on" v-model="fields.comes_on" v-bind:class="{ 'is-invalid' : errors.comes_on }">
                    <option value="" disabled>Maak een keuze</option>
                    <option value="1">Zaterdag</option>
                    <option value="2">Zondag</option>
                    <option value="3">Zaterdag en zondag</option>
                </select>
            </div>
            <div class="form-group">
                <label for="introduce">Introducé *</label>
                <select class="form-control" id="introduce" v-model="fields.introduce" v-bind:class="{ 'is-invalid' : errors.introduce }">
                    <option value="" disabled>Maak een keuze</option>
                    <option value="1">Ja</option>
                    <option value="0">Nee</option>
                </select>
            </div>
            <div class="form-group" v-if="fields.introduce == 1">
                <label for="introduce_name">Naam introducé *</label>
                <input type="text" class="form-control" id="introduce_name" v-model="fields.introduce_name" v-bind:class="{ 'is-invalid' : errors.introduce_name }">
            </div>
            <div class="form-group" v-if="fields.introduce == 1">
                <label for="introduce_email">E-mailadres introducé *</label>
                <input type="email" class="form-control" id="introduce_email" v-model="fields.introduce_email" v-bind:class="{ 'is-invalid' : errors.introduce_email }">
            </div>
            <div class="form-group">
                <label for="barbeque">Barbeque *</label>
                <select class="form-control" id="barbeque" v-model="fields.barbeque" v-bind:class="{ 'is-invalid' : errors.barbeque }">
                    <option value="" disabled>Maak een keuze</option>
                    <option value="1">Ja</option>
                    <option value="0">Nee</option>
                </select>
            </div>
            <div v-if="fields.barbeque == 1">
                <div class="form-group">
                    <label for="barbeque_persons">Aantal personen voor de barbeque *</label>
                    <input type="number" class="form-control" id="barbeque_persons" v-model="fields.barbeque_persons" v-bind:class="{ 'is-invalid' : errors.barbeque_persons }">
                </div>
                <div class="form-group">
                    <label>Hoe wilt u de barbeque betalen? *</label>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" v-model="fields.payment_method" id="payment_methodbanktransfer" value="banktransfer" v-bind:class="{ 'is-invalid' : errors.payment_method }">
                        <label class="form-check-label" for="payment_methodbanktransfer">
                            Overboeken<br><small class="text-muted">Per persoon voor de barbeque € {{ parseFloat(priceBbq).toFixed(2) }} overmaken op rek nr "NL27 RABO 0134 0715 14" onder vermelding van barbecue, naam en aantal personen.</small>
                        </label>
                    </div>
                    <div class="form-check" v-for="(paymentMethod, index) in paymentMethods" :key="index">
                        <input class="form-check-input" type="radio" v-model="fields.payment_method" :id="'payment_method' + paymentMethod.id" :value="paymentMethod.id" v-bind:class="{ 'is-invalid' : errors.payment_method }">
                        <label class="form-check-label" :for="'payment_method' + paymentMethod.id">
                            {{ paymentMethod.description }}
                        </label>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label for="overnight">Overnachting *</label>
                <select class="form-control" id="overnight" v-model="fields.overnight" v-bind:class="{ 'is-invalid' : errors.overnight }">
                    <option value="" disabled>Maak een keuze</option>
                    <option value="1">Ja</option>
                    <option value="0">Nee</option>
                </select>
            </div>

            <h3 class="mt-3">Voertuigen</h3>

            <p>Geef in onderstaande velden op met welk(e) voertuig(en) u komt. In het eerste veld, kan het type voertuig worden opgegeven. In het tweede veld, het merk/model en in het laatste veld het bouwjaar.</p>

            <table class="table">
                <thead>
                    <tr>
                        <th>Type *</th>
                        <th>Naam *</th>
                        <th width="110">Bouwjaar *</th>
                        <td width="30"></td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(subscriptionvehicle, index) in fields.subscriptionvehicles" :key="index">
                        <td>
                            <select class="form-control" v-model="subscriptionvehicle.type" v-bind:class="{ 'is-invalid': errors['subscriptionvehicles.' + index + '.type'] }">
                                <option value="" disabled>Maak een keuze</option>
                                <option value="Tractor">Tractor</option>
                                <option value="Auto/vrachtwagen">Auto/vrachtwagen</option>
                                <option value="Motor">Motor</option>
                                <option value="Brommer">Brommer</option>
                                <option value="Anders">Anders</option>
                            </select>
                        </td>
                        <td>
                            <input type="text" class="form-control" v-model="subscriptionvehicle.name" v-bind:class="{ 'is-invalid': errors['subscriptionvehicles.' + index + '.name'] }">
                        </td>
                        <td>
                            <select class="form-control" v-model="subscriptionvehicle.year" v-bind:class="{ 'is-invalid': errors['subscriptionvehicles.' + index + '.year'] }">
                                <option value="" disabled>Bouwjaar</option>
                                <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                            </select>
                        </td>
                        <td>
                            <button type="button" class="btn btn-outline-danger" v-if="index > 0" @click="deleteSubscriptionvehicle(index)">
                                <i class="fa fa-fw fa-trash-o"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <button type="button" class="btn btn-outline-success" @click="addSubscriptionvehicle">
                <i class="fa fa-fw fa-plus"></i> Voertuig toevoegen
            </button>

            <div class="form-check mt-3">
                <input class="form-check-input" type="checkbox" value="1" v-model="fields.insurance" id="insurance" v-bind:class="{ 'is-invalid' : errors.insurance }">
                <label class="form-check-label" for="insurance">
                    Hierbij verklaart de deelnemer dat hij/zij en voertuigen een geldige WA-verzekering hebben
                </label>
            </div>

            <div class="form-check mt-3">
                <input class="form-check-input" type="checkbox" value="1" v-model="fields.agree_rules" id="agree_rules" v-bind:class="{ 'is-invalid' : errors.agree_rules }">
                <label class="form-check-label" for="agree_rules">
                    Ik ga <a href="/docs/reglement.pdf" target="_blank">akkoord met het reglement</a>
                </label>
            </div>

            <div class="alert alert-danger mt-3" v-if="hasErrors()">
                U heeft niet alle velden juist ingevuld. Corrigeer de rood gemarkeerde velden.
            </div>

            <button type="submit" class="btn btn-lg btn-success btn-block mt-3">
                Inschrijven
            </button>
        </form>
    </div>
</template>

<script>
import { FormMixin } from '@/mixins/FormMixin';

export default {
    name: 'SubscriptionForm',

    mixins: [
        FormMixin
    ],

    props: {
        event: {
            type: Object,
            required: true
        },
        paymentMethods: {
            type: Object,
            required: true,
        },
        priceBbq: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            fields: {},
            subscriptionSuccess: false,
            years: []
        }
    },
    mounted() {
        for(let i = 1900; i <= new Date().getFullYear(); i++) {
            this.years.push(i);
        }

        this.resetFields();
    },

    methods: {
        resetFields () {
            this.fields = {
                firstname: '',
                lastname: '',
                postcode: '',
                address: '',
                city: '',
                telephone: '',
                email: '',
                comes_on: '',
                introduce: '',
                introduce_name: '',
                introduce_email: '',
                barbeque: '',
                barbeque_persons: '',
                payment_method: '',
                payment_issuer: '',
                overnight: '',
                subscriptionvehicles: [{
                    type: '',
                    name: '',
                    year: ''
                }]
            };
        },
        submit () {
            this.$api.post('/inschrijven/' + this.event.uuid, this.fields).then((response) => {
                window.location.href = response.data.url;
            }).catch((error) => {
                this.requestError(error);
            });
        },
        addSubscriptionvehicle() {
            this.fields.subscriptionvehicles.push({
                type: '',
                name: '',
                year: ''
            });
        },
        deleteSubscriptionvehicle(index) {
            this.fields.subscriptionvehicles.splice(index, 1);
        },
    }
}
</script>
